import { HOUSEHOLD_PATHS } from 'constants/paths';

export const QUESTIONS_PER_PAGE = 3;

/**
 * The admission preferences an applicant can be asked about, in the order the staff-side waitlist
 * configuration page lists them. Product asked for that order over the design's so a preference
 * sits in the same place whichever application you are looking at.
 *
 * It is not the order a property stores its selections in, so this array — not the enabled list
 * arriving on the app context — is what fixes the sequence of questions.
 *
 * The ids come from the staff-side waitlist configuration, whose validator accepts any string. This
 * is the portal's home for the applicant-facing copy attached to each one; an id that is not listed
 * here renders no question rather than a raw message key.
 */
export const PREFERENCE_QUESTIONS = [
  'veteran',
  'fosterCare',
  'involuntarilyDisplaced',
  'disability',
  'elderly',
  'homeless',
  'rentBurden',
  'residency',
  'victim',
  'workingFamilies',
].map((id) => ({
  id,
  nameId: `afforda.householdPreferences.${id}.name`,
  descriptionId: `afforda.householdPreferences.${id}.description`,
}));

/**
 * Derived rather than written out again, so the ten ids keep the single home above. Referenced by
 * `HOUSEHOLD_PATHS_TO_FIELD_NAMES_MAP` to find the answers to clear when a property stops asking
 * preference questions altogether.
 */
export const PREFERENCES_FIELD_NAMES = PREFERENCE_QUESTIONS.reduce(
  (fieldNames, { id }) => ({ ...fieldNames, [id]: id }),
  {},
);

/**
 * The four fixed steps the questions are shown on, in flow order. Three questions to a page covers
 * all ten, so a property can never need a fifth.
 *
 * The single home for the page set: the household step list, the routes and the page hook all read
 * their ordering from here.
 */
export const PREFERENCE_PAGE_PATHS = [
  HOUSEHOLD_PATHS.PREFERENCES_1,
  HOUSEHOLD_PATHS.PREFERENCES_2,
  HOUSEHOLD_PATHS.PREFERENCES_3,
  HOUSEHOLD_PATHS.PREFERENCES_4,
];
